module.exports = __webpack_public_path__ + "files/085e13b04d21ba51edaa67f7ff74ff89.png";